/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)


import "@popperjs/core"
import '@fortawesome/fontawesome-free/js/all.min'
// import $ from 'jquery'; // added this to try to get it working
//import 'bootstrap'
import * as bootstrap from 'bootstrap'
import '../idea_manage_invite_collapse'
import '../select_user_profile_modal'
import '../user_profile_edit_about_autosize'

// Make Bootstrap available globally
window.bootstrap = bootstrap;
console.log('Bootstrap loaded:', typeof bootstrap !== 'undefined');

// Add to app/javascript/packs/application.js
import { initCustomCollapse } from './collapse';
window.initCustomCollapse = initCustomCollapse; // Make it globally available

//document.addEventListener("turbolinks:load", () => {
  // Initialize all modals
//  document.querySelectorAll('.modal').forEach(modalElement => {
//    new bootstrap.Modal(modalElement);
//  });
//});

console.log('Application.js loaded')

function initBootstrapDropdowns() {
  if (!window.bootstrap || !window.bootstrap.Dropdown) return
  document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((toggle) => {
    try {
      window.bootstrap.Dropdown.getOrCreateInstance(toggle)
    } catch (_e) {
      /* invalid markup */
    }
  })
}

function onTurbolinksLoad() {
  console.log('turbolinks:load')
  initRoomChatComposer()
  initBootstrapDropdowns()

  // Initialize all modals once
  document.querySelectorAll('.modal').forEach(modalElement => {
    // Only initialize if not already initialized
    if (!bootstrap.Modal.getInstance(modalElement)) {
      new bootstrap.Modal(modalElement, {
        backdrop: true,
        keyboard: true,
        focus: true
      });
    }
  });

  const siteShowPage = document.getElementById('site-show-page')
  if (siteShowPage && siteShowPage.dataset.openAllPositions === 'true') {
    const positionsModal = document.getElementById('siteAllPositionsModal')
    if (positionsModal && window.bootstrap) {
      let inst = bootstrap.Modal.getInstance(positionsModal)
      if (!inst) inst = new bootstrap.Modal(positionsModal)
      inst.show()
      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href)
        if (url.searchParams.has('all_positions')) {
          url.searchParams.delete('all_positions')
          window.history.replaceState({}, '', url.pathname + url.search + url.hash)
        }
      }
    }
  }
}

document.addEventListener('turbolinks:load', onTurbolinksLoad)
document.addEventListener('turbo:load', onTurbolinksLoad)

function initBootstrapDropdownClickShim () {
  // TODO(dropdown): Temporary compatibility shim. Remove after fixing the
  // underlying click/event interference that blocks Bootstrap's data-api handler.
  if (window.__bootstrapDropdownClickShimBound) return
  window.__bootstrapDropdownClickShimBound = true

  document.addEventListener('click', (e) => {
    const el = clickEventTargetElement(e)
    const toggle = el && el.closest ? el.closest('[data-bs-toggle="dropdown"]') : null
    if (!toggle) return
    if (!window.bootstrap || !window.bootstrap.Dropdown) return
    if (toggle.classList.contains('disabled') || toggle.getAttribute('aria-disabled') === 'true') return
    e.preventDefault()
    try {
      window.bootstrap.Dropdown.getOrCreateInstance(toggle).toggle()
    } catch (_err) {
      // ignore invalid markup edge cases
    }
  }, true)
}

initBootstrapDropdownClickShim()

//import 'bootstrap/dist/js/bootstrap.bundle';
//import $ from 'jquery';
//import { createPopper } from '@popperjs/core';
/*
document.addEventListener('DOMContentLoaded', function() {
  const popperElement = document.getElementById('popper-element');
  const triggerButton = document.getElementById('popper-trigger');

  if (popperElement && triggerButton) {
    createPopper(triggerButton, popperElement, {
      placement: 'top', // Popper will appear on top
    });
  }
});
*/

import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
//import "channels"; // was never working

//import channels from 'channels'; // doesn't work because channels are in the wrong place

//import { adminUtility } from './utility';


import {  siteUi } from './siteUi';
import {  generate } from './generate';
import './posts'; // Import posts.js
import '../conversations_compose_modal';
import { initRoomChatComposer } from '../room_chat_composer';
import '../org_users_pending_bulk';
import '../media_albums_bulk_permissions';
import '../media_albums_index';
//import './photos'; // Import photos.js
import 'easy-autocomplete';

Rails.start();
Turbolinks.start();
ActiveStorage.start();

// Text / comment nodes as event.target have no .closest; throwing here can break
// other document-level handlers (e.g. Bootstrap dropdown) on the same click.
function clickEventTargetElement(e) {
  const t = e.target
  if (t && t.nodeType === Node.ELEMENT_NODE) return t
  return t && t.parentElement
}

document.addEventListener('click', (e) => {
  const el = clickEventTargetElement(e)
  const btn = el && el.closest ? el.closest('[data-copy-target]') : null
  if (!btn || !btn.dataset.copyTarget) return
  e.preventDefault()
  const copySource = document.querySelector(btn.dataset.copyTarget)
  if (!copySource || !navigator.clipboard) return
  const text = copySource.textContent.trim()
  if (!text || text === '— none —') return
  navigator.clipboard.writeText(text).then(() => {
    const label = btn.getAttribute('data-copy-label') || 'Copy'
    btn.textContent = 'Copied!'
    setTimeout(() => { btn.textContent = label }, 2000)
  })
})

document.addEventListener('click', (e) => {
  const el = clickEventTargetElement(e)
  const copyPostBtn = el && el.closest ? el.closest('[data-post-copy-url]') : null
  if (!copyPostBtn || !copyPostBtn.dataset.postCopyUrl) return
  e.preventDefault()
  const url = copyPostBtn.dataset.postCopyUrl
  const label = copyPostBtn.getAttribute('data-post-copy-label') || copyPostBtn.textContent.trim()
  if (!navigator.clipboard || !url) return
  navigator.clipboard.writeText(url).then(() => {
    copyPostBtn.textContent = 'Copied!'
    setTimeout(() => { copyPostBtn.textContent = label }, 2000)
  }).catch(() => {})
})

document.addEventListener('click', (e) => {
  const el = clickEventTargetElement(e)
  const shareBtn = el && el.closest ? el.closest('[data-post-native-share]') : null
  if (!shareBtn) return
  e.preventDefault()
  const title = shareBtn.dataset.shareTitle || ''
  const text = shareBtn.dataset.shareText || ''
  const url = shareBtn.dataset.shareUrl || window.location.href
  if (navigator.share) {
    navigator.share({ title, text, url }).catch(() => {})
  } else if (navigator.clipboard) {
    navigator.clipboard.writeText(url).then(() => {
      const orig = shareBtn.textContent
      shareBtn.textContent = 'Link copied'
      setTimeout(() => { shareBtn.textContent = orig }, 2000)
    }).catch(() => {})
  }
})